<template>
  <!-- Analysis -->
  <div class="whole-page-long">
    <div class="navbar-div">
      <MarketsReportsComponent :user="user" analysis="CREATEREPORT" />
    </div>
  </div>
</template>

<script>
import MarketsReportsComponent from "@/components/markets/Reports.vue";

export default {
  name: "blog",
  components: {
    MarketsReportsComponent
  },
  data() {
    return {
      user: {}
    };
  },
  created() {
    document.title = "Blog | QS";
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
